export default "__VITE_ASSET__BAStXMGz__"